import { calculateTimeDifference } from '@riise/shared/utils/functions/calculate-time-difference';
import { OTHERS } from '@riise/shared/utils/constants/others';
import { LanguageSwitcherComponent } from '../../language-switcher/language-switcher.component';
import { SpaceComponent } from '../space/space.component';
import { Component, OnInit, inject, signal, computed } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Menu, NavService } from '@riise/core/services/nav/nav.service';
import { SwitcherService } from '@riise/core/services/switcher/switcher.service'
import { User, getAuth } from "firebase/auth";
import { AuthService } from '@riise/core/services/firebase/auth.service';
import { NotificationsService } from '@riise/core/services/notifications/notifications.service';
import { NotificationDirective } from '@riise/shared/directives/notification.directive';
import { NotificationPush } from '@riise/shared/directives/notification-push.directive';
import { NotificationRouter } from '@riise/shared/directives/notification-router.directive';
import { UserData } from '@riise/shared/utils/functions/users';
import { CryptoService } from '@riise/core/services/crypto/crypto.service';
import { StateService } from '@riise/core/services/state/state.service';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DirectivesModule } from '@riise/shared/directives/directives.module';


@Component({
  selector: 'app-header',
    imports: [
      CommonModule,
      TranslateModule,
      RouterModule,
      NgbModule,
      DirectivesModule,
      LanguageSwitcherComponent,
      SpaceComponent
    ],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  private notificationsService = inject(NotificationsService);
  private userData = inject(UserData);
  private SwitcherService = inject(SwitcherService);
  private navServices = inject(NavService);
  private auth = inject(AuthService);
  private router = inject(Router);
  private modalService = inject(NgbModal);
  private notificationDirective = inject(NotificationDirective);
  private NotificationPush = inject(NotificationPush);
  private notificationRouter = inject(NotificationRouter);
  private stateService = inject(StateService);
  private translateService = inject(TranslateService);
  private crypto = inject(CryptoService);


  public menuItems: Menu[] = [];
  public items: Menu[] = [];
  public text: string= "";
  public SearchResultEmpty: boolean = false;
  public isCollapsed = true;
  userId = this.userData?.userId;
  userInfos = this.userData?.userInfos;
  space = this.userData?.space
  role = this.userData?.role
  currency = this.userData?.currency
  flags = this.userData?.flags
  index = this.userData?.index
  SPACES = OTHERS.SPACES
  currentFirebaseUser: User | null = null;
  activeAllNotifications = signal<any>("");
  notifications = signal<any>([]);
  messages = signal<any>([]);
  target: any;
  time: any;
  public readonly MESSAGE_TYPE_IDS = [8, 13, 14, 15, 17];
  public selectedNotifTab = signal<string>('all'); // Onglet sélectionné pour notifications
  public allNotifications = signal<any[]>([]);
  public isNotificationPage: boolean = false;

  /** Inserted by Angular inject() migration for backwards compatibility */




  constructor() { }



  // Ouvrir le switcher
  toggleSwitcher() {
    this.SwitcherService.emitChange(true);
  }


  // Déconnexion
  signout(){
    localStorage.removeItem("user")
    localStorage.removeItem("index")
    localStorage.removeItem("NoahorizontalHover")
    getAuth().signOut();
    this.router.navigate(['/'], { replaceUrl: true, })
    setTimeout(() => {location.reload();}, 100);
  }


  // Ouvrir le modal
  open(content:any) {
    this.modalService.open(content, {backdrop : 'static' , windowClass : 'modalCusSty', size: 'lg' })
  }



  // Changement d'espace
  onSelectSpace(event: Event) {
    this.target = <HTMLInputElement>event.target;
  }



  // Changement d'espace
  onChangeSpace() {
    if (this.target?.checked) {
      if (this.target?.value != this.index) {
        this.router.navigate(['/dashboard']);
        let timerInterval: any;
        Swal.fire({
          title: "Changement d'espace",
          html: "Chargement des données <b></b>",
          timer: 3000,
          didOpen: () => {
            Swal.showLoading();
            const container = Swal.getHtmlContainer();
            if (container) {
              const b = container.querySelector('b');
              if (b) {
                timerInterval = setInterval(() => {
                  const timeLeft = Swal.getTimerLeft();
                  b.textContent = timeLeft !== undefined ? timeLeft.toString() : '';
                }, 100);
              }
            }
          },
          willClose: () => {
            clearInterval(timerInterval);
          },
        }).then((result: any) => {
          if (result.dismiss === Swal.DismissReason.timer) {
            localStorage.setItem('index', this.target?.value);
            this.navServices.items.subscribe((menuItems) => {
              this.items = menuItems;

            });
            location.reload();
          }
        });
      }
    }
  }


  // Calcul du temps écoulé depuis la notification
  calculateTimeDifference(inputDate: any) {
    return calculateTimeDifference(inputDate, this.translateService)
  }



  // Route vers la page de la notification
  returnToNotifications(){
    this.router?.navigate(['/notifications'])
  }


  // Route vers la page de la notification
  route(reference: Number, id: Number, type: Number, isActive: boolean): void {
    return this.notificationRouter?.route(reference, id, type, isActive)
  }



  ngOnInit(): void {
    this.initializeNotifications();
    this.setupSubscriptions();
  }

  private initializeNotifications(): void {
    this.NotificationPush?.requestPermission();
    this.currentFirebaseUser = getAuth()?.currentUser || null;
    this.loadNotification(this.userId);
    this.checkNotificationPage();
  }

  private checkNotificationPage(): void {
    // Vérifie si on est sur la page des notifications
    this.router?.events?.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.isNotificationPage = event?.url?.startsWith('/notifications');
      }
    });

    // Vérifie aussi à l'init
    this.isNotificationPage = this.router?.url?.startsWith('/notifications');
  }

  private setupSubscriptions(): void {
    // S'abonne à la notification pour mettre à jour les notifications
    this.notificationDirective?.notification$.pipe(
      filter(value => value !== "null")
    ).subscribe({
      next: (value: any) => {
        const notificationId = value?.type?.id;
        if (notificationId == 35) {
          this.notificationsService.showAnnouncementPopup(value?.reference);
        }
        this.loadNotification(this.userId);
      }
    });

    // S'abonne à l'état pour mettre à jour les notifications
    this.stateService?.update$?.pipe(
      filter(value => value !== "null")
    ).subscribe({
      next: () => {
        this.loadNotification(this.userId);
      }
    });
  }

  loadNotification(userId: any): void {
    this.notificationsService.getUserNotifications({
        user_Id_In: this.userId
    }).subscribe((result: any) => {
        const all = result?.data?.NotificationsNode?.edges || [];
        this.allNotifications.set(all);

        this.messages.set([]);
        this.notifications.set(all);

        this.activeAllNotifications.set(all.filter(
          (notifications: any) => notifications?.node?.isActive === true
        ).length);
      }, (error: any) => {
        this.notifications.set([]);
        this.activeAllNotifications.set(0);
      }
    );
  }




  public filteredNotifications = computed(() => {
    let list = [];
    const currentTab = this.selectedNotifTab();
    const notifs = this.notifications();

    if (currentTab === 'all') {
      list = notifs;
    } else if (currentTab === 'unread') {
      list = notifs?.filter((notification: any) => notification?.node?.isActive);
    }
    return list.slice(0, 50);
  });

  public limitedMessages = computed(() => {
    return this.messages().slice(0, 50);
  });


  markAllAsReadFront() {
    // Optimisme UI : on met tout à false côté front
    const all = this.allNotifications();
    all?.forEach((notification: any) => {
      if (notification?.node) notification.node.isActive = false;
    });

    this.notifications.set([...this.notifications()]); // Trigger update
    this.activeAllNotifications.set(0);
  }


  markAllAsRead() {
    // Optimisme UI : on met tout à false côté front
    this.markAllAsReadFront();

    // requête côté back pour marquer toutes les notifications et messages comme lues
    this.notificationsService?.markNotificationAsRead(
      this.userId
    ).subscribe((result:any) => {
      this.loadNotification(this.userId);
    });
  }


}
